import React from 'react';

export interface JourneySectionCardProps {
  className?: string;
  title?: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

function cx(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(' ');
}

export const JourneySectionCard: React.FC<JourneySectionCardProps> = ({
  className,
  title,
  description,
  actions,
  children,
}) => (
  <section className={cx('journey-section-card', className)}>
    {title || description || actions ? (
      <header className="journey-section-card__header">
        <div className="journey-section-card__title-block">
          {title ? <h3>{title}</h3> : null}
          {description ? <p>{description}</p> : null}
        </div>
        {actions}
      </header>
    ) : null}
    {children}
  </section>
);

export const SectionCard = JourneySectionCard;

export default JourneySectionCard;
